import React from "react";
import { PageMessage } from "@picklebet/ui";
import { useIsMobile } from "@/hooks/useDisplay";
import { ReactComponent as EmptyIcon } from "@/features/casino/components/assets/empty-state.svg";
import { Button } from "@picklebet/ui";
import { useShellStore } from "@/features/shell/stores/shellStore";
import * as styles from "@/features/betslip/components/Empty.module.scss";

const EmptyWithActiveGameSessions = () => {
  const isMobile = useIsMobile();
  const setModal = useShellStore((state) => state.setModal);

  return (
    <PageMessage
      className={styles.container}
      image={<EmptyIcon />}
      title={`Active Casino session`}
      subTitle={`End your active Casino session to place bets`}
    >
      <Button
        size={isMobile ? "sm" : "md"}
        onClick={() => setModal("endGameSession")}
      >
        End Session
      </Button>
    </PageMessage>
  );
};

export { EmptyWithActiveGameSessions };
